<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">업무전달</span>
            <span class="txt">직원 간 업무를 전달 할 수 있도록 글을 작성할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link :to="`/madmin/board/list`" class="com-btn">목록</router-link>
                </div>
            </div>
            <table class="com-table edit">
                <colgroup>
                    <col style="width: 150px" />
                    <col style="width: 560px" />
                    <col style="width: 150px" />
                    <col style="width: 560px" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>제목</th>
                        <td>{{ workList.title }}</td>
                        <th>글쓴이</th>
                        <td>{{ writerName }}</td>
                    </tr>
                    <tr>
                        <th>참석팀</th>
                        <td>{{ workList.joinTeamName }}</td>
                        <th>조회수</th>
                        <td>{{ workList.viewCount }}</td>
                    </tr>
                    <tr>
                        <th>상태</th>
                        <td>
                            <select-form
                                :disabled="centerStaffId != workList.centerStaffId"
                                :select-data="['진행중', '처리완료']"
                                :select-value="['O', 'C']"
                                :selected-value="writeState"
                                class="w160"
                                @update:set="(val) => (writeState = val)"
                            ></select-form>
                            <button
                                :disabled="centerStaffId != workList.centerStaffId"
                                class="com-btn light-blue"
                                @click="changeState"
                            >
                                변경
                            </button>
                        </td>
                        <th>등록일</th>
                        <td>{{ workList.noticeStartDate }}</td>
                    </tr>
                    <tr>
                        <th>참석팀</th>
                        <td colspan="3">
                            <div
                                v-for="(staff, index) in workStaffList"
                                :key="index"
                                :class="{
                                    disabled:
                                        centerStaffId != staff.center_staff_id &&
                                        centerStaffId != workList.centerStaffId,
                                }"
                                class="info-txt-check"
                            >
                                <span class="txt">{{ staff.center_staff_nm }}</span>
                                <div class="check-line flex">
                                    <div class="com-radio">
                                        <input
                                            :id="`user-radio-${index}-1`"
                                            v-model="staffChcek[index]"
                                            :disabled="
                                                centerStaffId != staff.center_staff_id &&
                                                centerStaffId != workList.centerStaffId
                                            "
                                            :name="`user-radio-${index}`"
                                            type="radio"
                                            value="O"
                                            @change="attndChange"
                                        />
                                        <label :for="`user-radio-${index}-1`">진행중</label>
                                    </div>
                                    <div class="com-radio">
                                        <input
                                            :id="`user-radio-${index}-2`"
                                            v-model="staffChcek[index]"
                                            :disabled="
                                                centerStaffId != staff.center_staff_id &&
                                                centerStaffId != workList.centerStaffId
                                            "
                                            :name="`user-radio-${index}`"
                                            type="radio"
                                            value="C"
                                            @change="attndChange"
                                        />
                                        <label :for="`user-radio-${index}-2`">완료</label>
                                    </div>
                                </div>
                            </div>
                            <!--
                        <div class="info-txt-check">
                            <span class="txt">최성연</span>
                            <div class="check-line">
                                <div class="com-radio">
                                    <input type="radio" name="user-radio-1" id="user-radio-1-1" checked>
                                    <label for="user-radio-1-1">진행중</label>
                                </div>
                                <div class="com-radio">
                                    <input type="radio" name="user-radio-1" id="user-radio-1-2">
                                    <label for="user-radio-1-2">완료</label>
                                </div>
                            </div>
                        </div>
                        <div class="info-txt-check disabled">
                            <span class="txt">이지수</span>
                            <div class="check-line">
                                <div class="com-radio">
                                    <input type="radio" name="user-radio-2" id="user-radio-2-1" disabled checked>
                                    <label for="user-radio-2-1">진행중</label>
                                </div>
                                <div class="com-radio">
                                    <input type="radio" name="user-radio-2" id="user-radio-2-2" disabled>
                                    <label for="user-radio-2-2">완료</label>
                                </div>
                            </div>
                        </div>
                        --></td>
                    </tr>
                    <tr>
                        <td class="no-padding no-side-border" colspan="4">
                            <div class="txt-view">
                                <div class="ck-content" v-html="workList.content"></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="replay-area">
                <div class="write-box">
                    <span class="tit">댓글</span>
                    <div class="input-line">
                        <input v-model="replyText" placeholder="댓글을 입력하세요" type="text" />
                        <button class="com-btn" @click="updateReply">등록</button>
                    </div>
                </div>
                <div class="list-box">
                    <ul class="list">
                        <li v-for="(item, index) in this.workList.centerTaskStaffComments" :key="index">
                            <span class="name">{{ item.center_staff_nm }}</span>
                            <p v-if="!commentEdit || index != commentId" class="txt">{{ item.comment }}</p>
                            <div v-if="commentEdit && index == commentId">
                                <input v-model="item.comment" type="text" />
                                <button
                                    v-if="commentEdit"
                                    class="com-btn"
                                    @click="replyAction('update', item.center_task_staff_comment_id, item.comment)"
                                >
                                    댓글 수정
                                </button>
                            </div>
                            <span class="day">{{ item.upd_dt | timestampFilter }}</span>
                            <button
                                v-if="centerStaffId == item.center_staff_id"
                                class="modify"
                                @click="editComment(index)"
                            >
                                <span class="blind">수정하기</span>
                            </button>
                            <button
                                v-if="centerStaffId == item.center_staff_id"
                                class="del"
                                @click="replyAction('delete', item.center_task_staff_comment_id, item.comment)"
                            >
                                <span class="blind">삭제하기</span>
                            </button>
                        </li>
                        <!--
                        <li>
                            <span class="name">김하연</span>
                            <p class="txt">스터디는 아무나 참석 할 수 있는 것인가요? 인원수 제한은 몇명이에요?</p>
                            <span class="day">2019.08.22</span>
                            <button class="modify"><span class="blind">수정하기</span></button>
                            <button class="del"><span class="blind">삭제하기</span></button>
                        </li>
                        -->
                    </ul>
                </div>
            </div>

            <div class="com-btn-area">
                <div class="right-box">
                    <router-link :to="`/madmin/board/list`" class="com-btn">목록</router-link>
                    <router-link :to="`/madmin/board/edit`" class="com-btn blue">글 등록</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../../../assets/js/api';

export default {
    name: 'BoardDetail',
    props: {},
    computed: {},
    data() {
        return {
            commentEdit: false,
            centerId: this.$route.params.centerId,
            centerTaskId: this.$route.params.centerTaskId,
            centerStaffId: this.$store.state.auth.user.uid,
            isLoading: false,
            workList: {},
            workStaffList: [],
            staffChcek: [],
            writerName: '',
            replyText: '',
            writeState: '',
            commentId: '',
        };
    },
    mounted() {
        this.onSearchList();
    },
    methods: {
        async onSearchList() {
            try {
                this.isLoading = true;
                // this.isStopPopup = isStopPopup;
                const { data } = await this.getWorkList();
                this.workList = data;
                this.workStaffList = data.centerTaskStaffs;
                this.workStaffList.forEach((element, index) => {
                    this.staffChcek[index] = element.staff_status_cd;
                    if (this.workList.centerStaffId == element.center_staff_id) {
                        this.writerName = element.center_staff_nm;
                    }
                });
                this.writeState = data.status;
                this.isLoading = false;

                console.log('===> Success Loading : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        getWorkList() {
            return api.get(`/admin/api/centerTask/detail/${this.centerId}/${this.centerTaskId}`);
        },
        async changeState(val) {
            // console.log( val );
            try {
                const { data } = await this.onChangeStat();
                alert('게시글 상태가 변경되었습니다.');
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },

        onChangeStat() {
            return api.put(`/admin/api/centerTask/updateStatus`, {
                centerId: this.centerId,
                centerTaskId: this.centerTaskId,
                status: this.writeState,
            });
        },
        async updateReply() {
            if (this.replyText.length < 1) {
                return;
            }

            try {
                const replyData = {
                    centerId: this.centerId,
                    centerTaskId: this.centerTaskId,
                    centerStaffId: this.centerStaffId,
                    comment: this.replyText,
                };

                const data = await this.sendPostReply(replyData);
                console.log(data);
                alert('등록 되었습니다.');
                this.replyText = '';
                this.onSearchList(); // 리프레쉬
            } catch (error) {
                alert('등록 실패했습니다.');
                console.log(error);
            }
        },

        sendPostReply(data) {
            return api.post('/admin/api/centerTask/createComment', {
                ...data,
            });
        },

        // 참석자 상태 변경 API
        attendStatus() {
            const datas = [];
            for (const i in this.workStaffList) {
                datas.push({
                    centerStaffId: this.workStaffList[i].center_staff_id,
                    staffStatus: this.staffChcek[i],
                });
            }
            console.log('데이터값', datas);
            return api.put(`/admin/api/centerTask/updateStaffStatus/${this.centerId}/${this.centerTaskId}`, {
                datas,
            });
        },
        // 상태변경시 확인
        async attndChange() {
            try {
                const { data } = await this.attendStatus();
                console.log(data);
                console.log('체크', this.staffChcek);
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        async replyAction(action, staffId, comment) {
            try {
                const { data } = await this.getReplyAction(action, staffId, comment);
                if (action == 'update') {
                    alert('값이 수정되었습니다.');
                    this.commentEdit = false;
                    this.onSearchList();
                } else {
                    alert('값이 삭제되었습니다.');
                    this.onSearchList();
                }
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        getReplyAction(action, staffId, comment) {
            return api.put(`/admin/api/centerTask/updateComment/${action}`, {
                centerId: this.centerId,
                centerTaskId: this.centerTaskId,
                centerStaffId: this.centerStaffId,
                centerTaskStaffCommentId: staffId,
                comment,
            });
        },
        // commentEdit(){
        //     this.commentEdit = true
        // },
        editComment(index) {
            this.commentId = index;
            this.commentEdit = !this.commentEdit;
        },
    },
};
</script>
<style lang="scss"></style>
